/**
 * Created by Nikolai Gorte
 * User: n.gorte on 15.09.2016
 * Copyright: xdot GmbH 2016
 */

import React from 'react';
import PropTypes from 'external/prop-types';

const ProgressBar = ({ height = 10, color = '#66d9ff', percentage, children }) => {
    if (isNaN(percentage) || percentage <= 0) {
        percentage = 0
    } else if (percentage >= 100) {
        percentage = 100
    }

    const style = {
        backgroundColor: color,
        width: percentage + '%',
        transition: "width 200ms",
        height: height
    };

    return <div className="progressbar-container">
        <div className="progressbar" style={style}>{children}</div>
    </div>

};

ProgressBar.propTypes = {
    children: PropTypes.node,
    height: PropTypes.number,
    color: PropTypes.string,
    percentage: PropTypes.number
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./js/components/ProgressBar.jsx